import { createAction, props } from '@ngrx/store';
import { TreeNode } from 'primeng/api';

export const loadMenu = createAction('MenuLoad');
export const loadMenuSuccess = createAction('MenuLoadSuccess', props<{ nodes: TreeNode[] }>());
export const loadMenuFailure = createAction('MenuLoadFailure', props<{ error: any }>());

export const toggleExpanded = createAction('MenuToggleExpanded', props<{ key: string; expanded: boolean }>());
export const selectNode = createAction('MenuSelectNode', props<{ key: string }>());
export const refreshMenu = createAction('MenuRefresh');

